import React, { useEffect, useState, useMemo } from 'react';
import { useSelector } from 'react-redux';
import AddRole from '@rsos/components/capstone/RolesShared/AddRole';
import {
  MAX_ROLES_COUNT,
  REQUIRED_ROLE,
} from '@rsos/components/capstone/RolesShared/utils/constants';
import { selectUserOrgByApp, selectManagementByApp } from '@rsos/sinatra';
import DataSourcesForm from '../../components/DataSources';
import {
  DataSourcesContainer,
  DataSourcesWrapper,
  DataSourcesHeader,
} from './DataSourcesManagement.styles';

const DataSourcesManagement = () => {
  const [dataSources, setDataSources] = useState([]);
  const sinatra = useSelector(state => state.sinatra);
  const { application, permissions } = sinatra.user.currentRole;
  const org = selectUserOrgByApp(sinatra, application);

  const management = selectManagementByApp(sinatra, org.id, application);

  const allRoles = useMemo(
    () => (management?.roles?.records?.length ? management.roles.records : []),
    [management?.roles?.records],
  );

  const allPermissions = useMemo(
    () =>
      management?.permissions?.records.length
        ? management?.permissions?.records
        : [],
    [management?.permissions?.records],
  );

  const isMaxRolesCountReached = allRoles.length >= MAX_ROLES_COUNT;

  useEffect(() => {
    const filteredPermissions = allPermissions.filter(p => !p.rsp_rbac); //needed to filter out Page access permissions
    const mappedDataSources = filteredPermissions.map(d => ({
      ...d,
      isDisabled: d.roles.length === allRoles.length, // this is for checkbox to assign roles
    }));
    // Sort alphabetically by display_name
    const sortedDataSources = mappedDataSources.sort((a, b) =>
      a.display_name.localeCompare(b.display_name),
    );
    setDataSources(sortedDataSources);
  }, [management, allPermissions, allRoles]);

  return (
    <DataSourcesWrapper>
      <DataSourcesContainer>
        <DataSourcesHeader>Data Sources by Role</DataSourcesHeader>
        {permissions.includes(REQUIRED_ROLE) && (
          <AddRole
            roles={allRoles}
            isMaxRolesCountReached={isMaxRolesCountReached}
          />
        )}
        <DataSourcesForm dataSources={dataSources} roles={allRoles} />
      </DataSourcesContainer>
    </DataSourcesWrapper>
  );
};

export default DataSourcesManagement;
